import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { Sigma } from "lucide-react";

const ROLES = [
  { v: "learner", label: "Learner — study the library" },
  { v: "contributor", label: "Contributor — solve & submit" },
  { v: "customer", label: "Customer — commission work" },
  { v: "reviewer", label: "Reviewer — verify submissions" },
];

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "learner" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await register(form);
    setLoading(false);
    if (res.ok) {
      toast.success(`Welcome to Axioms, ${res.user.name}`);
      navigate("/dashboard");
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div className="mx-auto flex min-h-[80vh] max-w-md flex-col justify-center px-5 py-12" data-testid="register-page">
      <div className="mb-8 flex items-center gap-2">
        <Sigma className="h-6 w-6 text-[#E61A27]" />
        <h1 className="font-display text-3xl text-slate-900">Join Axioms</h1>
      </div>
      <form onSubmit={submit} className="axiom-card space-y-4 p-7">
        <div>
          <label className="eyebrow">Full name</label>
          <input data-testid="register-name" required value={form.name} onChange={set("name")}
            className="mt-2 w-full rounded-lg border border-[#CBD5E1] bg-slate-50 px-4 py-3 text-slate-900 outline-none focus:border-[#E61A27]" />
        </div>
        <div>
          <label className="eyebrow">Email</label>
          <input data-testid="register-email" type="email" required value={form.email} onChange={set("email")}
            className="mt-2 w-full rounded-lg border border-[#CBD5E1] bg-slate-50 px-4 py-3 text-slate-900 outline-none focus:border-[#E61A27]" />
        </div>
        <div>
          <label className="eyebrow">Password</label>
          <input data-testid="register-password" type="password" required minLength={6} value={form.password} onChange={set("password")}
            className="mt-2 w-full rounded-lg border border-[#CBD5E1] bg-slate-50 px-4 py-3 text-slate-900 outline-none focus:border-[#E61A27]" />
        </div>
        <div>
          <label className="eyebrow">I am joining as</label>
          <select data-testid="register-role" value={form.role} onChange={set("role")}
            className="mt-2 w-full rounded-lg border border-[#CBD5E1] bg-slate-50 px-4 py-3 text-slate-900 outline-none focus:border-[#E61A27]">
            {ROLES.map((r) => <option key={r.v} value={r.v} className="bg-[#FFFFFF]">{r.label}</option>)}
          </select>
        </div>
        <button data-testid="register-submit" disabled={loading} className="btn-crimson w-full">
          {loading ? "Creating…" : "Create account"}
        </button>
      </form>
      <p className="mt-5 text-center text-sm text-slate-500">
        Already registered? <Link to="/login" className="text-[#D4AF37] hover:underline">Sign in</Link>
      </p>
    </div>
  );
}
